import React from 'react';
import { Grid } from '@material-ui/core';
import PlataformasExternas from './PlataformasExternas';
import { MoodleImage, MaterialImage, TotvsImage, CanvasImage } from '../../../assets/images/portal/iconsPortal';

const PlataformasExternasList = () => {
  return (
    <Grid container spacing={2} justifyContent="center">
      <PlataformasExternas
        isSvg
        title={'Material didático'}
        subtitle={'Material didático do estudante e recursos a serem utilizados nas aulas.'}
        image={
          MaterialImage
        }
        link={''}
      />

      <PlataformasExternas
        isSvg
        title={'moodle'}
        subtitle={'Sistema de gerenciamento acadêmico.'}
        image={
          MoodleImage
        }
        link={''}
      />

      <PlataformasExternas
        isSvg
        title={'TOTVS'}
        subtitle={'Plataformas para empresas que oferece tecnologia completa para digitalização dos negócios, apoiando o crescimento, levando mais produtividade, eficiência e rentabilidade para as operações dos clientes.'}
        image={
          TotvsImage
        }
        link={''}
      />

      <PlataformasExternas
        isSvg
        title={'canvas'}
        subtitle={'Plataforma de gerenciamento de aprendizagem número um do mundo.'}
        image={
          CanvasImage
        }
        link={''}
      />
    </Grid>
  );
};

export default PlataformasExternasList;
